module.exports = __webpack_public_path__ + "static/media/priceImage2.3512c949.svg";